import React from 'react';
import { ExchangeTradesPropsType } from '../Types';
import AutoCompleteField from '../base/AutoCompleteField';
import { handleExchangeProductChange, isCrude } from '../common';

interface ProductBFieldProps extends ExchangeTradesPropsType {}

export function ProductBField(props: ProductBFieldProps) {
    const { state, options } = props;

    let productBDisabled = props.disabled || isCrude(props.options.crude_products, state.productB.value);

    return (
        <AutoCompleteField
            options={options.products.filter((product) => product !== state.productA.value)}
            inputValue={state.productB.value}
            handleChange={(newVal: string) => {
                handleExchangeProductChange(props, state.productA, {
                    value: newVal,
                    error: '',
                    required: state.productB.required,
                    summary: <span>{newVal}</span>,
                });
            }}
            errorText={state.productB.error}
            required={state.productB.required}
            label={'Product B'}
            width={130}
            disabled={productBDisabled}
            marginLeft={'16px'}
        />
    );
}
